/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

//@ts-nocheck
import React, { useEffect, useState } from "react";
import "react-responsive-modal/styles.css";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { EventBusModule } from "@vlinder-web/event-bus-module-react";
import { LoginPageVP } from "./component";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { useSessionStorage } from "react-use-storage";
export interface LoginModalVWProps {
    open?: boolean;
    apiURL: string;
    onLoginSuccess?(user?: any): void;
}

export const LOGIN_MODAL_OPEN = "LoginModalVW:Open";
export const LOGIN_MODAL_CLOSE = "LoginModalVW:Close";
export const LOGIN_SUCCESS = "LoginModalVW:LoginSuccess";

const log: any = LoggerModule.getInstance();

const MODAL_ITEMS = {
    open: false,
};

export const LoginModalVW = (props: LoginModalVWProps) => {
    const eb = EventBusModule.getInstance().getEventBus();
    const [item, setItem] = useState(MODAL_ITEMS);
    const [value, setValue, removeValue] = useSessionStorage("authToken");
    // debugger;

    useEffect(() => {
        _subscribe();
        return _unsubscribe;
    });

    const _subscribe = () => {
        eb.on(LOGIN_MODAL_OPEN, onModalOpen);
        // eb.on(LOGIN_MODAL_CLOSE, onModalClose);
        // eb.on(LOGIN_SUCCESS, onLoginSuccess);
    };

    const _unsubscribe = () => {
        eb.off(LOGIN_MODAL_OPEN, onModalOpen);
        // eb.off(LOGIN_MODAL_CLOSE, onModalClose);
        // eb.off(LOGIN_SUCCESS, onLoginSuccess);
    };

    const onModalOpen = (props: any) => {
        console.log(`in openModal item:`, props);
        if (item.open === false) {
            setItem({
                open: true,
                ...{ ...(props || {}) },
            });
        }
    };

    const onModalClose = () => {
        eb.emit(LOGIN_MODAL_CLOSE, null, {});
        if (item.open) {
            setItem({
                ...MODAL_ITEMS,
                open: false,
            });
        }
    };

    const onLoginSuccess = (res) => {
        log.info("user Login Success", res);
        setValue("123456789");
        if (res?.authToken) {
            setValue("123456789");
        }
        eb.emit(LOGIN_SUCCESS, null, {
            loginUser: res,
        });
        if (item.open) {
            setItem({
                ...MODAL_ITEMS,
                open: false,
            });
        }
    };

    const _getModal = () => {
        if (item?.open) {
            return (
                <Modal
                    isOpen={item?.open}
                    toggle={onModalClose}
                    fullwidth={true}
                    size={"lg"}
                    centered={true}
                    animation={false}
                    fade={false}
                    style={{ width: "100%" }}
                >
                    <ModalHeader toggle={onModalClose}></ModalHeader>
                    <ModalBody>
                        <LoginPageVP
                            {...props}
                            enableSignup={true}
                            onLoginSuccess={onLoginSuccess}
                        />
                    </ModalBody>
                </Modal>
            );
        }
    };

    return <>{_getModal()} </>;
};
